/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcGenerateV1MonthlyStatementsJobEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_GENERATE_V1_MONTHLY_STATEMENTS_JOB_EVENT_ENTITY_NAME = 'ixc.generate.v1.MonthlyStatementsJobEvent';
export const ixcGenerateV1MonthlyStatementsJobEventEntity = new schema.Entity<IxcGenerateV1MonthlyStatementsJobEvent>(IXC_GENERATE_V1_MONTHLY_STATEMENTS_JOB_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcGenerateV1MonthlyStatementsJobEvent) => `${entity.metadata?.eventId}` });

